




import { defineComponent } from "@nuxtjs/composition-api";
export default defineComponent({
  name: "MenuContext",
  props: {
    contents: {
      type: String,
      default: "",
    },
  },
});
